<template>
  <div>
    <a
      v-if="fileUrl"
      :href="fileUrl"
      target="_blank"
      rel="noopener noreferrer"
    >{{ $t('File') }}</a>
    <p v-else>
      {{ $t('Not found') }}
    </p>
  </div>
</template>

<script>

export default {
  name: 'PdfViewer',
  props: {
    url: {
      type: String,
      default: '',
    },
  },
  computed: {
    fileUrl() {
      if (!this.url || !this.url.trim()) return ''

      try {
        const file = new URL(this.url, window.location.origin)
        return ['http:', 'https:'].includes(file.protocol) ? file.href : ''
      } catch (error) {
        return ''
      }
    },
  },
  watch: {
    fileUrl: {
      immediate: true,
      handler(url) {
        // Media responses prohibit framing; open saved viewer links at the top level.
        if (url) window.location.replace(url)
      },
    },
  },
}
</script>

<style scoped>

</style>
